import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'numberFormat',
    standalone: false
})
export class NumberFormatPipe implements PipeTransform {
  transform(value: number | string, separator: string = " "): string {
    if (value == null) {
      return '';
    }
    const numberValue = typeof value === 'string' ? parseFloat(value) : value;
    return numberValue.toLocaleString('en-US').replace(/,/g, separator);
  }
}
